import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { AlarmClock } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Shown when the check-in was opened from a reminder (iPhone has no notification buttons).
export const SnoozeBar = () => {
  const [params] = useSearchParams();
  const [done, setDone] = useState(false);
  if (params.get("reminder") !== "1") return null;
  const snooze = async () => {
    try {
      await api.post("/push/snooze");
      setDone(true);
      toast.success("Okay — we'll remind you in 30 minutes 💜");
    } catch (e) { toast.error(errMsg(e, "Could not snooze")); }
  };
  return (
    <div className="mm-soft p-4 mb-6 flex items-center justify-between gap-3" data-testid="checkin-snooze-bar">
      <span className="text-sm">{done ? "Snoozed. Take care of what you need to 💜" : "Busy right now?"}</span>
      {!done && (
        <button onClick={snooze} className="mm-btn-ghost !py-1.5 !px-3 text-sm inline-flex items-center gap-1.5 shrink-0" data-testid="checkin-snooze">
          <AlarmClock size={15} /> Remind me in 30 min
        </button>
      )}
    </div>
  );
};
